import { LinkButton } from '@/atoms/Button'
import { InternalLink } from '@/atoms/InternalLink'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { CaptionXS, HeadingXS, ParagraphSM } from '@/atoms/Text'
import { paths } from '@/constants'
import { useLoginUrl, useSignupUrl } from '@/utils/auth-utils'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { WatchBackground } from '../WatchLandingView/WatchBackground'

export const WelcomeView = () => {
  const { t } = useTranslate('sign-up')
  const returnUrl = paths.guild.pricing
  const { loginUrl, trackLoginStarted } = useLoginUrl(returnUrl)
  const { signupUrl, trackSignupStarted } = useSignupUrl(returnUrl)

  return (
    <>
      <main className="relative h-screen overflow-y-hidden">
        <WatchBackground />
        <div className="my-3 flex justify-center sm:mx-6 sm:my-4 sm:justify-start">
          <InternalLink aria-label="Angel Studios" href={paths.home}>
            <AngelLogo height={40} color="white" />
          </InternalLink>
        </div>
        <section className="flex min-h-screen items-center justify-center">
          <div className="mx-auto flex h-fit max-w-[500px] flex-col gap-4 rounded-2xl bg-gray-100 px-4 py-8 backdrop-blur-xl md:px-10 lg:gap-4">
            <div className="flex flex-col gap-2 px-8 py-2">
              <HeadingXS weight="bold" className="md:photon-heading-sm max-w-[250px]">
                {t('welcomeAngelStudios', 'Welcome to Angel Studios.')}
              </HeadingXS>
              <ParagraphSM weight="medium" className="!text-core-gray-600">
                {t(
                  'ourAwardWinningEntertainment',
                  'Our Award-Winning entertainment is handpicked by our audience and supported by our fans.',
                )}
              </ParagraphSM>
            </div>
            <div className="flex flex-col gap-2 px-8 md:gap-4 lg:gap-2 lg:py-2">
              <LinkButton
                href={signupUrl}
                onClick={() => trackSignupStarted('WelcomeView')}
                variant="gray-400"
                className="border-0 !bg-core-gray-300 px-7 py-[17px] hover:!bg-core-gray-400"
              >
                {t('createAnAccount', 'Create an Account')}
              </LinkButton>
              <LinkButton
                href={loginUrl}
                onClick={() => trackLoginStarted('WelcomeView')}
                variant="gray-400"
                className="border-0 !bg-core-gray-300 px-7 py-[17px] hover:!bg-core-gray-400"
              >
                {t('returningUser', 'Returning User')}
              </LinkButton>
            </div>
            <CaptionXS weight="medium" className="px-8 py-2 !text-core-gray-500">
              <Translate t={t} i18nKey="signupTermsPrivacyPolicy">
                By signing up and logging in you agree to the{' '}
                <a href={paths.legal.termsOfUse} className="underline" target="_blank">
                  terms of use
                </a>{' '}
                and{' '}
                <a href={paths.legal.privacyPolicy} className="underline" target="_blank">
                  privacy policy
                </a>
                .
              </Translate>
            </CaptionXS>
          </div>
        </section>
      </main>
    </>
  )
}
